var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"l-body",class:[_vm.classOS],style:({

       }),attrs:{"id":"app"}},[_c('router-view',{attrs:{"name":"background"}}),_vm._v(" "),_c('modals-keep'),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('cookie-law')],1)}
var staticRenderFns = []

export { render, staticRenderFns }